import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import moment from "moment";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import DatePicker from "react-datepicker";

import { createFormRequest, editFormRequest } from "../../api/form";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect";

class AttendanceForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                employee: null,
                date: null,
                timeIn: null,
                lunchStart: null,
                lunchEnd: null,
                timeOut: null,
                reason: null,
                approvedBy: null,
            },
            employeeSelectOptions: [],
            error: null,
            formErrors: null,
        };
    }

    componentDidMount() {
        // employeeSelectOptionRequest(
        //     (result) => this.setState({ employeeSelectOptions: result }),
        //     (error) => this.setState({ error: "There was an error" }),
        // );
    }

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    onChangeDate = (date, field) => {
        let value = moment(date).format("YYYY-MM-DD");

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [field]: value,
            },
        }));
    };

    errorMessage = (name, message) => {
        const { formErrors } = this.state;
        return (
            <>
                {formErrors && formErrors[name] && (
                    <div className="form-text text-danger sz-11px">
                        {message}
                    </div>
                )}
            </>
        );
    };

    validate = () => {
        const { employee, date, approvedBy } = this.state.resource;

        const errors = {};
        if (!employee) {
            errors.employee = true;
        }

        if (!date) {
            errors.date = true;
        }

        if (!approvedBy) {
            errors.approvedBy = true;
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ formErrors: errors });
        } else {
            this.setState({ formErrors: null });
            this.save();
        }
    };

    save = () => {
        const {
            employee,
            date,
            timeIn,
            lunchStart,
            lunchEnd,
            timeOut,
            reason,
            approvedBy,
        } = this.state.resource;

        const { instanceId } = this.props;

        const isNewRecord = !instanceId;

        let data = {
            employee,
            date,
            formType: "attendance",
            timeIn,
            lunchStart,
            lunchEnd,
            timeOut,
            reason,
            approvedBy,
        };

        if (isNewRecord) {
            createFormRequest(
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        } else {
            editFormRequest(
                instanceId,
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        }
    };

    saveSuccess = () => {
        const { employee } = this.state.resource;

        this.setState({ error: null });
        this.props.goToList(employee);
    };

    saveFailure = () => {
        this.setState({ error: "There was an error saving tag." });
    };

    handleChange = (employeeValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                employee: employeeValue.value,
            },
        }));
    };

    handleApproveChange = (approveValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                approvedBy: approveValue.value,
            },
        }));
    };

    render() {
        const {
            timeIn,
            lunchStart,
            lunchEnd,
            timeOut,
            reason,
        } = this.state.resource;

        const date = this.state.resource.date
            ? moment(this.state.resource.date, "YYYY-MM-DD").toDate()
            : "";

        return (
            <Row>
                <Col md={12}>
                    <Card
                        title="Attendance Form"
                        content={
                            <form>
                                <FormGroup>
                                    <ControlLabel>
                                        Employee
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleChange}
                                    />
                                    {/* <FormControl 
                        onChange={this.handleFormChange}
                        componentClass="select" 
                        name="employee"
                        value={employee}
                      >
                      <option value="">Select</option>
                      {employeeSelectOptions.map(option => {
                          return (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          );
                      })}
                    </FormControl> */}
                                    {this.errorMessage(
                                        "employee",
                                        "Employee can't be empty",
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>
                                        Date
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <DatePicker
                                        selected={date}
                                        onChange={(date) =>
                                            this.onChangeDate(date, "date")
                                        }
                                        dateFormat="MM/dd/yyyy"
                                        className="dateInput"
                                        dropdownMode="select"
                                        maxDate={new Date()}
                                    />
                                    {this.errorMessage(
                                        "date",
                                        "Date can't be empty",
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>No Time In</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, including seconds
                                        (eg: 13:55:00)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={timeIn}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>No Lunch Start</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, including seconds
                                        (eg: 13:55:00)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={lunchStart}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>No Lunch End</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, including seconds
                                        (eg: 13:55:00)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={lunchEnd}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>No Time Out</ControlLabel>
                                    <label className="form-helper-text">
                                        In 24 hours format, including seconds
                                        (eg: 13:55:00)
                                    </label>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={timeOut}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Reason</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="reason"
                                        value={reason}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>
                                        Approved By
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleApproveChange}
                                        placeholder={"Approved By"}
                                    />
                                    {/* <FormControl
                                        onChange={this.handleFormChange}
                                        componentClass="select"
                                        name="approvedBy"
                                        value={approvedBy}
                                    >
                                        <option value="">Select</option>
                                        {employeeSelectOptions.map((option) => {
                                            return (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </FormControl> */}
                                    {this.errorMessage(
                                        "approvedBy",
                                        "Approved By can't be empty",
                                    )}
                                </FormGroup>

                                <Button
                                    bsStyle="primary"
                                    pullRight
                                    fill
                                    onClick={this.validate}
                                >
                                    Submit Form
                                </Button>
                                <div className="clearfix" />
                            </form>
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default AttendanceForm;
